import { QuoteBlockBlock } from 'src/types/articleCmsTypes';

import s from './Quote.module.scss';

export function Quote({ text, author, post }: Omit<QuoteBlockBlock, 'type'>) {
  return (
    <q className={s.root}>
      <p dangerouslySetInnerHTML={{ __html: text }} />
      <span className={s.author} dangerouslySetInnerHTML={{ __html: author }} />
      <span
        className={s.subauthor}
        dangerouslySetInnerHTML={{ __html: post }}
      />
    </q>
  );
}
